'use client'

import { useQuery } from '@tanstack/react-query'
import { getPost } from '../actions/post.actions'
import type { Post } from '../post'
import { queryCachePolicy } from '@/shared/state/query-cache-policy'

export const postKeys = {
  /** Root prefix — matches every post query for broad invalidation. */
  all: ['post'] as const,
  byId: (id: string) => [...postKeys.all, 'byId', id] as const,
}

export const postQueryKey = postKeys.byId

export function usePost(
  id: string,
  options?: { initialData?: Post; staleTime?: number }
) {
  return useQuery({
    queryKey: postQueryKey(id),
    queryFn: () => getPost(id),
    staleTime: options?.staleTime ?? queryCachePolicy.app.staleTime,
    initialData: options?.initialData,
    enabled: !!id,
  })
}
